import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { AnimatedSection } from '@/components/ui/animated-section'
import { FEATURES } from '@/utils/constants'

export function Features() {
  return (
    <section id="features" className="py-20 bg-slate-50 dark:bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <AnimatedSection animation="fade-up">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold mb-4">
              Powerful Features for Modern Development
            </h2>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
              Everything you need to build, deploy, and maintain exceptional software with AI-powered assistance
            </p>
          </div>
        </AnimatedSection>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((feature, index) => (
            <AnimatedSection
              key={feature.title}
              animation="fade-up"
              delay={index * 100}
              threshold={0.1}
            >
              <Card className={`h-full transition-all duration-300 hover:shadow-lg hover:scale-105 ${
                feature.highlight ? 'border-blue-200 dark:border-blue-800 bg-blue-50/50 dark:bg-blue-900/20' : ''
              }`}>
                <CardHeader>
                  <div className="text-4xl mb-4 text-center">{feature.icon}</div>
                  <CardTitle className="flex items-center gap-2">
                    {feature.title}
                    {feature.highlight && (
                      <Badge variant="secondary" className="text-xs">
                        Core
                      </Badge>
                    )}
                  </CardTitle>
                  <CardDescription className="text-base leading-relaxed">
                    {feature.description}
                  </CardDescription>
                </CardHeader>
              </Card>
            </AnimatedSection>
          ))}
        </div>

        <AnimatedSection animation="fade-up" delay={900}>
          <div className="mt-16 text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-blue-100 to-purple-100 dark:from-blue-900/20 dark:to-purple-900/20 rounded-full">
              <span className="text-sm font-medium">And much more...</span>
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>
  )
}
